// @mui
import { enUS, esES, ptBR, zhCN } from '@mui/material/locale';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// Rótulos exibidos vêm de `t(lang.labelKey)` — ver `languages` nos arquivos em langs/.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    labelKey: 'languages.pt',
    value: 'pt',
    systemValue: ptBR,
    icon: '/assets/icons/flags/ic_flag_br.svg',
  },
  {
    labelKey: 'languages.en',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    labelKey: 'languages.es',
    value: 'es',
    systemValue: esES,
    icon: '/assets/icons/flags/ic_flag_es.svg',
  },
  {
    labelKey: 'languages.cn',
    value: 'cn',
    systemValue: zhCN,
    icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
];



export const DEFAULT_LANG = 'en';
